import {
  ChannelIcon,
  BufferIcon,
  ArrowLeftRightIcon,
  Dialog,
  Flex,
  Heading,
} from '@buffer-mono/popcorn'
import { Footer } from './components/Footer/Footer'

import { SwitchFromIGLoginToFBLoginCard } from './components/Card/SwitchFromIGLoginToFBLoginCard'

import styles from './SwitchFromIGLoginToFBLogin.module.css'

import type { JSX } from 'react'

export default function SwitchFromIGLoginToFBLogin({
  channelId,
}: {
  channelId: string
}): JSX.Element {
  return (
    <>
      <Dialog.Header className={styles.wrapper}>
        <Flex gap="sm" align="center">
          <BufferIcon size="small" />
          <ArrowLeftRightIcon size="small" color="subtle" />
          <ChannelIcon size="small" type="instagram" color="branded" />
        </Flex>
      </Dialog.Header>

      <Flex
        direction="column"
        align="center"
        gap="xs"
        className={styles.titleSubtitle}
      >
        <Dialog.Title>
          <Heading size="lg" align="center">
            Reconnect Instagram through Facebook
          </Heading>
        </Dialog.Title>

        <Dialog.Description className={styles.subtitle}>
          Increase posting reliability and get some extra features too!
        </Dialog.Description>
      </Flex>
      <Dialog.Body className={styles.body}>
        <Flex justify="center" gap="xl">
          <SwitchFromIGLoginToFBLoginCard channelId={channelId} />
        </Flex>
      </Dialog.Body>
      <Dialog.CloseButton />
      <Footer />
    </>
  )
}
